import { Translatable } from "@icc/shared/helpers";

export class RollerGuide {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    material: 'pvc' | 'alu' | 'steel' | 'wood';
    width: number;
    img: null | string;
    /** Prowadnica zwykła */
    normalGuide: null | boolean;
    /** Prowadnica kątowa */
    angleGuide: null | boolean;
    /** Prowadnica podwójna */
    doubleGuide: null | boolean;
    /** Prowadnica z odsadzeniem */
    insetGuide: null | boolean;
    /** Prowadnica "Nakładka" */
    overlayGuide: null | boolean;
    subguide: null | boolean;
    onEdge: boolean;
    between: boolean;
    order?: number;
    shutterTypes: number[];
    /** Wkład prowadnicy */
    child: null | RollerGuide;
    default?: boolean;
    length?: number | null;
    maxLength: number | null;
    colorGroupSetId: number | null;
    /** Grupy kolorów z dopłatami dla tego profilu */
    colorGroupsSurcharge?: number[];
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    cuttingPossibility?: boolean;
    guideDrillingOptionIds?: number[];
    withProfileChannel?: boolean;
    withMosquitoChannel?: boolean;

    /** Niezależna prowadnica podwójna (ustawiane po lewej stronie rolety) */
    normalDoubleGuide?: boolean;
    defaultNormalDoubleGuide?: boolean;
    forSingleShutter?: boolean;
    forIntegratedPleatedMosquitoScreen?: boolean;
    independentPleatedMosquitoScreenAvailable?: boolean;

    spacePleatedMosquitoScreen?: number | null;
    /** Rezerwa na cięcie: długość odejmowana od docelowej długości prowadnicy do obliczenia ceny [mm] */
    lengthAdjustment?: number | null;
}

export interface IccRollerGuide {
    id: number;
    extId: string;
    indexNo: string;
    material: 'pvc' | 'alu' | 'steel' | 'wood';
    name: string;
    width: number;
    maxLength: number | null;
    img: null | string;
    normalGuide: null | boolean;
    angleGuide: null | boolean;
    doubleGuide: null | boolean;
    overlayGuide: null | boolean;
    insetGuide: null | boolean;
    subguide: null | boolean;
    onEdge: boolean;
    between: boolean;
    order?: number;
    shutterTypes: number[];
    child: null | IccRollerGuide;
    colorGroupSetId: number;
    /** Grupy kolorów z dopłatami dla tego profilu */
    colorGroupsSurcharge?: number[];
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    cuttingPossibility?: boolean;
    guideDrillingOptionIds?: number[];
    montageTypeIds?: number[];
    withProfileChannel?: boolean;
    withMosquitoChannel?: boolean;
    forSingleShutter?: boolean;
    forIntegratedPleatedMosquitoScreen?: boolean;
    independentPleatedMosquitoScreenAvailable?: boolean;

    spacePleatedMosquitoScreen?: number | null;
    /** Rezerwa na cięcie: długość odejmowana od docelowej długości prowadnicy do obliczenia ceny [mm] */
    lengthAdjustment?: number | null;
}
